

// MovimientoAjuste.entity.js
export class construirMovimientoInventarioAjuste {
  constructor(idProducto, cantidad, periodoId, idReferencia = 9999, origen = "ajuste admin") {
    if (!idProducto) throw new Error("ID de producto requerido");
    if (!periodoId) throw new Error("Periodo requerido");
    if (!cantidad || cantidad <= 0) throw new Error("La cantidad debe ser mayor a 0");

    this.id_producto = idProducto;
    this.tipo_movimiento = "salida";
    this.cantidad = Number(cantidad);
    this.id_referencia = idReferencia; // <--- aquí ponemos 9999 por defecto
    this.origen = origen;
    this.observacion = `Salida por Ajuste ${idReferencia}`;
    this.created_by = 3;
    this.fecha_creacion = new Date().toISOString();
    this.periodo_id = periodoId;
  }

  actualizarCantidad(nuevaCantidad) {
    if (nuevaCantidad <= 0) throw new Error("Cantidad debe ser > 0");
    this.cantidad = nuevaCantidad;
  }

  generarObservacion() {
    this.observacion = `Salida por Ajuste ${this.id_referencia}`;
  }
}